export enum Partner {
  Cint = 1,
  Spectrum = 2,
  Dynata = 3,
  Adgem = 4,
  TheoremReach = 900,
  CpxResearch = 901,
  TapResearch = 902,
  Ayet = 903,
  Torox = 904,
  AyetSurveys = 905,
}
